import { render, staticRenderFns } from "./FilterIntegrationCard.vue?vue&type=template&id=482ac54e&scoped=true&"
import script from "./FilterIntegrationCard.vue?vue&type=script&lang=js&"
export * from "./FilterIntegrationCard.vue?vue&type=script&lang=js&"
import style0 from "./FilterIntegrationCard.vue?vue&type=style&index=0&id=482ac54e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ac54e",
  null
  
)

export default component.exports